import { Container } from "@mui/material";
import AppErrorBoundary from "components/Common/AppErrorBoundary";
import Loader from "components/Common/Loader";
import { Form, Formik } from "formik";
import { defaultValues } from "helpers/formFields";
import { validationSchemaRegistrationStep } from "helpers/formFields/registrationStep";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

const RegisterLR = (): React.ReactElement => {
  return (
    <AppErrorBoundary scope="Registration routes">
      <Suspense fallback={<Loader />}>
        <Formik
          enableReinitialize
          initialValues={defaultValues}
          validationSchema={validationSchemaRegistrationStep}
          onSubmit={() => {}}
        >
          <Form>
            <Container>
              <Outlet />
            </Container>
          </Form>
        </Formik>
      </Suspense>
    </AppErrorBoundary>
  );
};
export default RegisterLR;
